import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  const deliverables = [{
    title: 'La Guía Maestra PDF Shopify Express 48H',
    desc: 'El paso a paso sin relleno.'
  }, {
    title: "El Framework 'Mapa de 120 Minutos'",
    desc: 'Configuración técnica completa en solo 2 horas.'
  }, {
    title: 'La Fórmula de Descripción MVP',
    desc: 'Cómo escribir textos que venden sin ser copywriter.'
  }, {
    title: 'Estrategia de Tráfico de Guerrilla',
    desc: 'Cómo atraer tus primeros clientes sin invertir en anuncios costosos.'
  }, {
    title: 'Listado de Herramientas Gratuitas',
    desc: 'Para diseñar y editar como un profesional sin pagar suscripciones.'
  }];
  return <section className="py-24 bg-gray-50 px-4" data-id="element-108">
      <div className="max-w-5xl mx-auto" data-id="element-109">
        <div className="text-center mb-16" data-id="element-110">
          <h2 className="text-4xl md:text-5xl font-bold text-navy-900 mb-4" data-id="element-111">
            Lo Que Obtienes Hoy
          </h2>
          <div className="w-24 h-1 bg-brandOrange-500 mx-auto" data-id="element-112"></div>
        </div>

        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-200" data-id="element-113">
          <div className="p-8 md:p-12" data-id="element-114">
            <div className="space-y-6" data-id="element-115">
              {deliverables.map((item, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.1
            }} className="flex items-start gap-4" data-id="element-116">
                  <CheckCircle2Icon className="w-8 h-8 text-green-500 flex-shrink-0 mt-1" data-id="element-117" />
                  <div data-id="element-118">
                    <h4 className="text-xl font-bold text-navy-900" data-id="element-119">
                      {item.title}
                    </h4>
                    <p className="text-gray-600 text-lg" data-id="element-120">{item.desc}</p>
                  </div>
                </motion.div>)}

              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.6
            }} className="mt-8 bg-brandOrange-50 border-2 border-brandOrange-200 rounded-xl p-6 flex items-start gap-4" data-id="element-121">
                <GiftIcon className="w-10 h-10 text-brandOrange-500 flex-shrink-0" data-id="element-122" />
                <div data-id="element-123">
                  <div className="inline-block bg-brandOrange-500 text-white text-xs font-bold px-2 py-1 rounded uppercase tracking-wide mb-2" data-id="element-124">
                    Bonus Especial
                  </div>
                  <h4 className="text-xl font-bold text-navy-900" data-id="element-125">
                    Plantilla de Mensajes de Venta Directa
                  </h4>
                  <p className="text-gray-700 text-lg" data-id="element-126">
                    Scripts probados para cerrar a tus primeros 10 clientes por
                    chat.
                  </p>
                </div>
              </motion.div>
            </div>
          </div>

          <div className="bg-navy-900 p-8 text-center" data-id="element-127">
            <p className="text-white text-xl mb-6 font-medium" data-id="element-128">
              Todo esto valorado en más de $97, hoy por una fracción del precio.
            </p>
            <CTAButton href="#price-block" data-id="element-129" />
          </div>
        </div>
      </div>
    </section>;
}